export default __webpack_public_path__ + "static/media/terms.a7085cbc.md";